import styled from 'styled-components';
import HouseKeepingIconSvg from '../../assets/hotels/amenities/housekeeping.svg';

const HouseKeepingIcon = styled(HouseKeepingIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1.5rem'};
  fill: ${props => props.fill || props.theme.colors.downriver.medium};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default HouseKeepingIcon;
